import SpaceBetween from '@cloudscape-design/components/space-between';
import { MarketingContainer, SectionHeader } from '@vextura/shell';
import type { ReactNode } from 'react';
import { NOT_FOR_YOU } from '../content.js';

/**
 * NotForYouIf — attract by rejecting. Classic YC move. Puts three
 * disqualifying statements on the page; the right customer feels seen.
 */
export function NotForYou(): ReactNode {
  return (
    <MarketingContainer paddingY="default">
      <SpaceBetween size="xl">
        <SectionHeader
          eyebrow="Honesty"
          headline={NOT_FOR_YOU.headline}
          subhead={NOT_FOR_YOU.subhead}
        />
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            margin: '0 auto',
            maxWidth: 640,
            display: 'grid',
            gap: 12,
          }}
        >
          {NOT_FOR_YOU.bullets.map((b) => (
            <li
              key={b}
              style={{
                background: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: 10,
                padding: '16px 20px',
                fontSize: 16,
                color: '#334155',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 12,
              }}
            >
              <span style={{ color: '#94a3b8', flexShrink: 0, marginTop: 2 }}>—</span>
              {b}
            </li>
          ))}
        </ul>
      </SpaceBetween>
    </MarketingContainer>
  );
}
